import script from "./PersonnelArchivesView.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonnelArchivesView.vue?vue&type=script&setup=true&lang=js"

import "./PersonnelArchivesView.vue?vue&type=style&index=0&id=343ed453&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-343ed453"]])

export default __exports__